import type { DefaultValue } from '../../common/data';
import type { TopNavbarProps } from './data.d';

const defaultValue: DefaultValue & TopNavbarProps = {
  componentName: 'navbar',
  name: '页面全局配置',

  backgroundColor: '#f7f7f7',
  headColor: 'linear-gradient(to bottom, #5AA6FF 0, #5AA6FF 84px,  #5AA6FF60 130px, #5AA6FF00 210px)',
  img: undefined,

  color: {
    bgColor: '',
    scrollBgColor: '#fff',
  },
  showTitle: 1,
  title: undefined,
  fontColor: {
    color: '#fff',
    scrollColor: undefined,
  },
}

export default defaultValue;
